export default "__VITE_ASSET__CNAU3jAL__"